import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ALogo } from '../components/atoms';
import { OLogin } from '../components/organisme';

import { login } from '../redux/cms/cmsActions';

class LoginPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			username: '',
			password: '',
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleBack = this.handleBack.bind(this);
		this.handleLogin = this.handleLogin.bind(this);
	}

	handleBack() {
		this.props.history.push('/');
	}

	handleLogin() {
		this.props.login({
			username: this.state.username,
			password: this.state.password,
		});
	}
	handleFieldChange({ key, value }) {
		this.setState({ [key]: value });
	}

	render() {
		if (this.props.token) {
			this.props.history.push('/cms');
		}

		return (
			<main className="layout--cms-login">
				<figure>
					<ALogo />
				</figure>
				<OLogin
					username={this.state.email}
					password={this.state.password}
					onUsernameChange={value => this.handleFieldChange({ key: 'username', value })}
					onPasswordChange={value => this.handleFieldChange({ key: 'password', value })}
					onBack={this.handleBack}
					onLogin={this.handleLogin}
				/>
			</main>
		);
	}
}
const mapStateToProps = state => ({
	token: state.cms.authentication.token,
	loginFailed: null,
});


export default withRouter(connect(mapStateToProps, {
	login,
})(LoginPage));



// WEBPACK FOOTER //
// ./src/CMS/login-page.js